import $ from 'jquery';
import DDTemplates from 'dd-templates';

import Drupal from './Drupal';
import BrowserCheck from './BrowserCheck';
import Header from './Header';
import Footer from './Footer';
import Menu from './Menu';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import HeroSlider from './HeroSlider';
import Gallery from './Gallery';
import CalendarFeed from './CalendarFeed';
import Placeholder from './placeholder';
import Notify from './Notify';
import AccordionWrap from './AccordionWrap';
import BackgroundImage from './BackgroundImage';
import Slider from './Slider';
import StringSplit from './StringSplit';
import SelectFix from './SelectFix';
import ServicesMap from './ServicesMap';
import MapTooltip from './MapTooltip';
import Redirect from './Redirect';
import NextVideo from './NextVideo';
import DropdownBuilder from './DropdownBuilder';
import DropdownWrapper from './DropdownWrapper';
import TwitterFeed from './TwitterFeed';
// import VertAlign from './VertAlign';

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers

  const $body = $(document.body, context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Get browser and version

  $('body', context).each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    $('.menuparent, .expanded, .collapsed', element).each((j, item) => {
      // handles the parent term (if hidden)
      const $parent = $(item).children('a');
      if (!$parent.length || $parent.is('.hidden')) {
        $(item).remove();
      }
      // handles the term to see if it only parents orphans.
      const $children = $('> ul > li', item);
      if (!$parent.is('.hidden') && $children.length) {
        const $orphans = $children.children('a.hidden');
        $orphans.parent().remove();
        if ($orphans.length === $children.length) {
          $(item).removeClass('expanded menuparent collapsed');
          $(item).children('ul').remove();
        }
      }
    });
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu) {
      element.menu = new Menu(element);
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display

  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer

  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Notifications

  $('.notifications', context).each((i, element) => {
    if (!element.notify && $(element).find('.node').length) {
      element.notify = new Notify(element);
    }
  });

  // Hero

  $('.hero', context).each((i, element) => {
    if (!element.heroSlider) {
      element.heroSlider = new HeroSlider(element);
    }
  });

  // Vertical Align Center

  // $('.hero .node-inner', context).each((i, element) => {
  //   if (!element.vertAlign) {
  //     element.vertAlign = new VertAlign(element);
  //   }
  // });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Twitter Feed

  $('.twitter-feed', context).each((i, element) => {
    if (!element.twitterFeed) {
      element.twitterFeed = new TwitterFeed(element);
    }
  });

  // Sliders

  $('.home-featured', context).each((i, element) => {
    if (!element.slider) {
      element.slider = new Slider(element);
    }
  });

  $('.dd-twitter-feed-tweets', context).each((i, element) => {
    if (!element.slider) {
      element.slider = new Slider(element, {
        wrapper: null,
        slide: '.tweet',
        slidesToShow: 3,
      });
    }
  });

  $('.home-videos', context).each((i, element) => {
    if (!element.slider) {
      element.slider = new Slider(element, {
        dots: false,
        arrows: true,
        slidesToShow: 2,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20px',
            dots: true,
            arrows: false,
          },
        }, {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            dots: true,
            arrows: false,
          },
        }],
      });
    }
  });

  // Wraps outer container in hyperlink

  $('.home-featured', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Allows partially hidden video to act as next button

  $('.home-videos', context).each((i, element) => {
    if (!element.nextVideo) {
      element.nextVideo = new NextVideo(element);
    }
  });

  // Sets image to background image

  $('.front .content-after', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        sourceSelector: '.home-videos-intro .field-image.c1 img',
      });
    }
  });
  $('.home-services, .banner', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
  });

  // Map Dropdown menu of the homepage

  $('.home-services', context).each((i, element) => {
    if (!element.memberMap) {
      const MemberMapInstanceConfiguration = {};
      if (!MemberMapInstanceConfiguration) {
        element.memberMap = new ServicesMap(element);
      } else {
        element.memberMap = new ServicesMap(element, MemberMapInstanceConfiguration);
      }
    }
  });

  // Tooltips

  $('#interactive-map text', context).each((i, element) => {
    if (!element.mapTooltip) {
      element.mapTooltip = new MapTooltip(element);
    }
  });

  // Wrap text before <br> in span

  $('.home-videos-intro, .home-services', context).each((i, element) => {
    if (!element.stringSplit) {
      element.stringSplit = new StringSplit(element);
    }
  });

  // Set placeholder of textfield using label

  $('.pods .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Home page departments dropdown

  $('.home-services .views-row', context).each((i, element) => {
    if (!element.dropDownWrapper) {
      element.dropDownWrapper = new DropdownWrapper(element);
    }
  });

  // Dropdown menus

  $('.home-services .views-row', context).each((i, element) => {
    if (!element.dropdownBuilder) {
      element.dropdownBuilder = new DropdownBuilder(element, { single: true });
      $(element).parents('.block').addClass('ready');
    }
  });

  // Wraps each accordion element

  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
    }
  });

  // Select List modifier
  $('.home-services .node-webform', context).each((i, element) => {
    if (!element.selectListFix) {
      element.selectListFix = new SelectFix(element, {
        trim: true,
        onChange: true,
      });
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Change ID: 'Join our mailing list' footer submit button
  $('#edit-actions #edit-submit-1', context).each((i, element) => {
    $(element).attr('id', 'edit-submit-999');
  });
});



// WEBPACK FOOTER //
// ./theme.js